import { render, staticRenderFns } from "./FormCotizacion.vue?vue&type=template&id=0fc6f1c3&scoped=true&"
import script from "./FormCotizacion.vue?vue&type=script&lang=ts&"
export * from "./FormCotizacion.vue?vue&type=script&lang=ts&"
import style0 from "./FormCotizacion.vue?vue&type=style&index=0&id=0fc6f1c3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc6f1c3",
  null
  
)

export default component.exports